// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/settings-services/settings-panel.scss
// module id = 470
// module chunks = 0